import { defineComponent, PropType } from 'vue';
import { mapState } from 'vuex';

import { RecordsCardMixin } from '@/bundles/Common/mixins/RecordsCardMixin';
import { IProperty } from '@/bundles/Property/interfaces/IProperty';
import { Nullable } from '@/utils/types';
import { formatPercent, formatRawNumber } from '@/utils/filters';

interface IAvailabilitiesCardMixinData {
  showLeaseAndSold: boolean;
}

export const AvailabilitiesCardMixin = defineComponent({
  mixins: [RecordsCardMixin],
  props: {
    property: {
      type: Object as PropType<IProperty>,
      default: () => ({} as IProperty),
    }
  },

  data: (): IAvailabilitiesCardMixinData => ({
    showLeaseAndSold: false,
  }),

  computed: {
    ...mapState({
      activeAccountId: (state: any) => state.activeAccount?.id
    }),
  },
});
